import type { EventSummary } from '../data/types'
import { deriveStatus } from '../data/registrationStatus'
import { formatEventDateRange } from '../data/format'
import { NoFlyerTile } from './NoFlyerTile'
import { StatusBadge, CtaButton } from './StatusBadge'
import { entryMeta } from './EventListCard'
import styles from './EventCard.module.css'

/** Flyers-view card, DesktopCards.dc.html: a large flyer shown uncropped (contain, on a blurred
 *  copy of itself) so organizer details stay readable. Desktop-only - the mobile view toggle has
 *  no Flyers option (Main.dc.html's segmented control is List/Calendar/Map only). */
export function EventFlyerCard({ event, canSignUp }: { event: EventSummary; canSignUp: boolean }) {
  const href = `/events/displayEvent.cfm?ID=${event.id}`
  const status = deriveStatus(event)

  return (
    <article className={styles.flyerCard}>
      <a href={href} aria-label={`View the ${event.name} flyer`} className={styles.flyerCardImageLink}>
        {event.flyerUrl ? (
          <>
            <img src={event.flyerUrl} alt="" className={styles.flyerCardBlur} />
            <img
              src={event.flyerUrl}
              alt={`${event.name} flyer - ${formatEventDateRange(event.startDT, event.endDT)} - ${event.trackName}`}
              className={styles.flyerCardImg}
            />
            <span className={styles.flyerCardFullSize} aria-hidden="true">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
              </svg>
              Full size
            </span>
          </>
        ) : (
          <NoFlyerTile id={event.id} name={event.name} raceType={event.raceType} caption="No flyer posted yet" />
        )}
      </a>
      <div className={styles.flyerCardBody}>
        <div className={styles.flyerCardDates}>{formatEventDateRange(event.startDT, event.endDT)}</div>
        <a href={href} className={styles.flyerCardTitle}>
          {event.name}
        </a>
        <div className={styles.flyerCardTrack}>{event.trackName}</div>
        <div className={styles.flyerCardCity}>
          {event.city}, {event.state}
        </div>
        <div className={styles.flyerCardFooter}>
          <StatusBadge status={status} />
          <div className={styles.flyerCardMetaRow}>
            {canSignUp ? <span className={styles.rowMeta}>{entryMeta(event, canSignUp)}</span> : null}
            <CtaButton status={status} href={href} canSignUp={canSignUp} />
          </div>
        </div>
      </div>
    </article>
  )
}
